/**
 * MOCK channel list (stay-informed-channels.md §2.1: "Category is reused as the subscription
 * taxonomy" — Category gains the same Kind field pattern as question topics, `Kind="channel"`).
 * Mirrors questionTopics.ts's shape/role.
 *
 * USE_MOCKS-fallback only — every live-aware surface reads channels from the real Kind=channel
 * Category entities instead: resident surfaces (SubscribePage/PreferencesPage) via ThemeProvider's
 * `channels` (fed by GET /api/public/embed-config, server-split by Kind); staff surfaces
 * (CategoriesAdmin's Channels tab, the broadcast "Send to" selector) via a live admin/embed read.
 * This mock list is the last-resort fallback if a live fetch returns an empty list (a brand-new
 * tenant with no channels configured yet) — never imported directly by a resident/staff page.
 */
import type { ChannelView } from "./types.js";

export const MOCK_CHANNELS: ChannelView[] = [
  { id: "road-closures", label: "Road closures & alerts", order: 0, defaultOn: true },
  { id: "community-events", label: "Community events", order: 1, defaultOn: false },
  { id: "council-agendas", label: "Council meetings & agendas", order: 2, defaultOn: false },
  { id: "utility-notices", label: "Utility notices (water, trash, sewer)", order: 3, defaultOn: true },
  { id: "emergency-alerts", label: "Emergency alerts", order: 4, defaultOn: true },
];
